import { render, staticRenderFns } from "./normalList.vue?vue&type=template&id=0f52fce0&scoped=true"
import script from "./normalList.vue?vue&type=script&lang=js"
export * from "./normalList.vue?vue&type=script&lang=js"
import style0 from "./normalList.vue?vue&type=style&index=0&id=0f52fce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52fce0",
  null
  
)

export default component.exports